export const PRODUCT_FIELDS = `
  fragment ProductFields on Product {
    id
    type
    name
    description
    thumbnail
  }
`
